import { __extends } from 'tslib';
import * as React from 'react';
import { UitkIcon } from 'uitk-react-icons';
import { UitkLayoutFlex, UitkLayoutFlexItem } from 'uitk-react-layout-flex';
import { classNames } from 'uitk-react-utils';
import styles from './uitk-switch.css';

var getClassNameList = classNames.bind(styles);
var UitkSwitch = /** @class */ (function (_super) {
    __extends(UitkSwitch, _super);
    function UitkSwitch() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    UitkSwitch.prototype.render = function () {
        var _a;
        var _b = this.props, checked = _b.checked, children = _b.children, className = _b.className, disabled = _b.disabled, description = _b.description, errorMessage = _b.errorMessage, id = _b.id, label = _b.label, labelClassName = _b.labelClassName, name = _b.name, onChange = _b.onChange, required = _b.required, switchPosition = _b.switchPosition, value = _b.value;
        var baseCssClass = 'uitk-switch';
        var wrapperClassNames = getClassNameList(baseCssClass, className, "uitk-switch-position-".concat(switchPosition), {
            'is-disabled': disabled
        });
        var labelCssClassNames = getClassNameList("uitk-switch-label", (_a = {},
            _a[labelClassName] = Boolean(labelClassName),
            _a['is-required'] = required,
            _a));
        var inputClassNames = getClassNameList({
            checked: checked
        });
        var controlClassNames = getClassNameList("".concat(baseCssClass, "-control"));
        var handleClassNames = getClassNameList("".concat(baseCssClass, "-control-handle"));
        var contentClassNames = getClassNameList("".concat(baseCssClass, "-content"));
        var labelContentClassNames = getClassNameList("".concat(baseCssClass, "-label-content"));
        var descriptionClassNames = getClassNameList("".concat(baseCssClass, "-description"));
        var errorClassNames = getClassNameList("".concat(baseCssClass, "-error"));
        var contents = label || children;
        return (React.createElement(UitkLayoutFlex, { className: wrapperClassNames, wrap: "nowrap" },
            React.createElement(UitkLayoutFlexItem, null,
                React.createElement(UitkLayoutFlex, null,
                    React.createElement(UitkLayoutFlexItem, { shrink: 0 },
                        React.createElement("input", { type: "checkbox", name: name || id, id: id, checked: checked, className: inputClassNames, onChange: onChange, value: value, "aria-invalid": errorMessage ? true : undefined, disabled: disabled, "aria-required": required })),
                    React.createElement(UitkLayoutFlexItem, { className: controlClassNames, shrink: 0 },
                        React.createElement("span", { "aria-hidden": "true" },
                            React.createElement("span", { className: handleClassNames },
                                React.createElement(UitkIcon, { name: checked ? 'check' : 'close' })))))),
            React.createElement(UitkLayoutFlexItem, { className: contentClassNames },
                React.createElement("div", null,
                    React.createElement("label", { className: labelCssClassNames, htmlFor: id },
                        React.createElement("span", { className: labelContentClassNames }, contents),
                        description && React.createElement("p", { className: descriptionClassNames }, description)),
                    errorMessage && React.createElement("p", { className: errorClassNames }, errorMessage)))));
    };
    UitkSwitch.displayName = 'UitkSwitch';
    UitkSwitch.defaultProps = {
        checked: false,
        switchPosition: 'leading'
    };
    return UitkSwitch;
}(React.Component));

export { UitkSwitch };
